<mat-card class="resultCard">
  <div>
    <div class="header">
      <img [src]="plate.imageUrl" class="image" (error)="setPlaceholderImage($event)" />
    </div>
    <div class="container">
      <div class="content">
        <div class="proccessTimestamp">
          <div *ngIf="plate.cameraName" class="cameraName">Captured By: {{ plate.cameraName }}</div>
          Processed At: {{ plate.eventTimestamp | fsFormatDate }}
        </div>
        <div class="mainContent">
          <div class="plate">
            {{ plate.plate }}
            <ng-container *ngIf="plate.plateState">({{ plate.plateState }})</ng-container>
          </div>
          <div class="plateActions">
            <button
              mat-icon-button
              [matMenuTriggerFor]="lprOptions"
              (click)="$event.stopPropagation()"
              *ngIf="!onMap"
            >
              <sn-icon>more_vert</sn-icon>
            </button>
          </div>
        </div>
        <div class="details">
          <div *ngIf="toStartCase(plate.vehicleType)">
            Vehicle Type:
            <ng-container>
              {{ toStartCase(plate.vehicleType) }}
            </ng-container>
          </div>
          <div *ngIf="!toStartCase(plate.vehicleType)">
            Vehicle Type:
            <ng-container> N/A </ng-container>
          </div>
          <div class="color">
            Color:
            <ng-container *ngIf="toStartCase(plate.color)">
              {{ toStartCase(plate.color) }}
            </ng-container>
            <ng-container *ngIf="!toStartCase(plate.color)"> N/A </ng-container>
          </div>
          <div *ngIf="toStartCase(plate.vehicleMake)">
            Make:
            <ng-container>
              {{ toStartCase(plate.vehicleMake) }}
            </ng-container>
          </div>
          <div *ngIf="!toStartCase(plate.vehicleMake)">
            Make:
            <ng-container> N/A </ng-container>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="nameAndTime">
          <div>
            <div *ngIf="plate.eventTimestamp">
              Captured At: {{ plate.eventTimestamp | fsFormatDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>

<mat-menu #lprOptions="matMenu">
  <button mat-menu-item (click)="sendToVault(plate)">
    <sn-icon>queue_play_next</sn-icon>
    <span>Send To Vault</span>
  </button>
  <button *ngIf="!onMap" mat-menu-item (click)="showOnMap(plate)">
    <sn-icon>gps_fixed</sn-icon>
    <span>Show On Map</span>
  </button>
</mat-menu>
